import React, { memo } from "react";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";
import clsx from "clsx";
import palette from "../../styles/palette";

const useStyles = makeStyles(({ typography }) => {
  const ten = typography.pxToRem(10);
  return {
    button: ({ rightButton }) => ({
      textTransform: "none",
      borderColor: palette.typography.black.solid,
      padding: `${typography.pxToRem(2)} ${ten}`,
      borderRadius: typography.pxToRem(16),
      margin: `${ten} 0`,
      marginLeft: rightButton ? "auto" : ten,
    }),
    deselected: {
      background: palette.typography.white.solid,
      color: palette.typography.black.solid,

      "&:hover": {
        background: palette.typography.white.solid,
      },
    },
    selected: {
      background: palette.typography.black.solid,
      color: palette.typography.white.solid,

      "&:hover": {
        background: palette.typography.black.solid,
      },
    },
    typography: {
      fontSize: typography.pxToRem(14),
    },
  };
});

const StopFilterButton = memo(
  ({ id, value, disabled, onClick, rightButton, selected }) => {
    const classes = useStyles({ rightButton });

    return (
      <Button
        variant="outlined"
        onClick={() => onClick(id)}
        disabled={disabled}
        disableRipple
        disableFocusRipple
        className={clsx(
          classes.button,
          selected ? classes.selected : classes.deselected
        )}
        data-testid={id}
      >
        {value}
      </Button>
    );
  }
);

export default StopFilterButton;
